import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { MastersService } from 'src/app/ngage-core/services/masters/masters.service';
import { MediaService } from 'src/app/ngage-core/services/media/media.service';
import { AppConfig } from 'src/app/App-Config';

@Injectable({
  providedIn: 'root'
})
export class LocalServerService {
  constructor(private master: MastersService, private mediaService: MediaService) { }

  fetchData(url) {
    return new Promise((resolve, reject) => {
      this.master.get(url).subscribe((res) => {
        resolve(res);
      });
    });
  }

  fetchmedia(id) {
    return new Promise((resolve, reject) => {
      this.mediaService.getMediaById(id).subscribe(res => {
        res.httpUrlObservable.subscribe((mediaHttpUrl) => {
          resolve(mediaHttpUrl);
        });
      });
    });
  }


  fetchSource(location) {
    let url = location.href.split("?");
    const reference = url[1] ? url[1].split("=") : false;
    const source = reference ? reference[0] === "source" ? reference[1] : false : false;
    if (source)
      localStorage.setItem('source', source);
  }

  removeReferenceFromLocal(){
    localStorage.removeItem('source');
  }


}